import React, {useEffect, useRef, useState} from "react";
import "./AddMerchant.scss";
import toaster from "toasted-notes";
import moment from "moment-jalaali";


function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function AddMerchant() {
    const inputFileRef = useRef( null );
    const [preview, setPreview] = useState()
    const [images,set_images] = useState([])
    const [load,set_load] = useState(false)
    const [start,set_start] = useState("1397/5/13")
    const [valu,set_valu] = useState("1397/5/15")

    useEffect(()=>{
        console.log(moment.jDaysInMonth(1398, 8))

    },[])

    const onFilechange = (e) =>{
        /*Selected files data can be collected here.*/
        console.log( e.target.files );
        if(e.target.files[0]){
            const objectUrl = URL.createObjectURL(e.target.files[0])
            setPreview(objectUrl)
            set_images(list=> [...list,objectUrl])
        }
    }

    const handleBtnClick = () => {
        /*Collecting node-element and performing click*/
        inputFileRef.current.click();
    }

    const rangeHandler = ({ startDate, stopDate }) => {
        console.log("ON_CHANGE_RANGE: ", { startDate, stopDate });
    };

    const submit = ()=>{
        let st = document.getElementsByClassName('rdp__input--start')[0].value;
        let en = document.getElementsByClassName('rdp__input--end')[0].value;
        console.log("dd",st,en)
        // set_load(true)
        // setTimeout(()=>{
        //     set_load(false);
        //     toaster.notify(({ onClose }) => (<Success message={"فروشگاه با موفقیت ثبت شد"}/>), {
        //         duration: 2000,
        //         position:"bottom"
        //     });
        // },2000)
    }

    return(
        <div className="add-merchant-container">

            {/*btn section*/}
            <div className="add-merchant-sec">
                <div className="add-merchant-btns">
                    <div className="add-merchant-btns-item clear">
                        <span>پاک کردن</span>
                    </div>
                    <div className="add-merchant-btns-item add"  onClick={()=>{submit()}}>
                        {load?<i className="fa fa-spinner fa-spin"></i>:
                            <span>ثبت</span>
                        }
                    </div>
                </div>
            </div>

            {/*body section*/}
            <div className="add-merchant-body">


                <div className="add-merchant-form">

                    <div className="add-merchant-form-item">
                        <select className="add-merchant-form-input" name="" id="">
                            <option value="">اپال</option>
                            <option value="">کوروش</option>
                            <option value="">ایرانمال</option>
                        </select>
                        <img src="/svg/add/mall.svg" alt=""/>
                    </div>

                    <div className="add-merchant-form-item">
                        <select className="add-merchant-form-input" name="" id="">
                            <option value="">پوشاک</option>
                            <option value="">غذایی</option>
                        </select>
                        <img src="/svg/add/group.svg" alt=""/>
                    </div>

                    <div className="add-merchant-form-item">
                        <input className="add-merchant-form-input" type="text" name="" id="" placeholder="نام فروشگاه"/>
                        <img src="/svg/add/merchant.svg" alt=""/>
                    </div>

                    <div className="add-merchant-form-item">
                        <input className="add-merchant-form-input" type="text" name="" id="" placeholder="طبقه"/>
                        <img src="/svg/add/floors.svg" alt=""/>
                    </div>

                    <div className="add-merchant-form-item">
                        <input className="add-merchant-form-input" type="text" name="" id="" placeholder="پلاک"/>
                        <img src="/svg/add/plak.svg" alt=""/>
                    </div>

                    <div className="add-merchant-form-item">
                        <input className="add-merchant-form-input" type="text" name="" id="" placeholder="تلفن"/>
                        <img src="/svg/add/phone.svg" alt=""/>
                    </div>
                </div>

                <div className="add-divider">

                </div>


                <div className="add-merchant-images">

                    <div className="add-merchant-images-item" onClick={()=>{
                        handleBtnClick()
                    }}>
                        <img src="/svg/add/image.svg" alt=""/>
                        <span>اضافه کردن</span>
                    </div>


                    {images.map(item=>{
                        return(
                            <div className="add-merchant-images-item"
                                 style={{backgroundImage: `url(${item})`}}
                            ></div>
                        )
                    })}

                </div>


                <input
                    className="file-image"
                    ref={inputFileRef}
                    onChange={onFilechange}
                    type="file" name="" id=""/>

            </div>

        </div>
    )
}

export {AddMerchant}
